import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./util/rem";
import "./style/common.less";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);

Vue.config.productionTip = false;

Vue.config.errorHandler = (err, vm, info) => {
  console.log("errorHandler", err, vm, info);
  // webErrorReport("DEBUG", "unknown", "vue error handler", { err, vm, info });
};
window.onerror = function (message, source, lineno, colno, error) {
  // webErrorReport("DEBUG", "unknown", "window error handler", {
  //   message,
  //   source,
  //   lineno,
  //   colno,
  //   error,
  // });
  console.log("捕获到的错误信息是：", message, source, lineno, colno, error);
};
window.addEventListener("unhandledrejection", function (e) {
  console.log("捕获到异常", e);
  e.preventDefault();
  // webErrorReport("DEBUG", "unknown", "unhandledrejection error handler", e);
});

// 获取用于显示宽度的元素
const widthElement: any = document.getElementById("app");
// 定义重绘页面的函数
function redrawPage() {
  // 获取当前窗口的宽度
  const windowWidth = window.innerWidth;
  // 更新页面上显示的宽度信息
  widthElement.textContent = windowWidth;
}
// 页面加载时先执行一次重绘
redrawPage();
// 监听窗口的 resize 事件，当窗口大小改变时触发 redrawPage 函数
window.addEventListener("resize", redrawPage);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
